// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboardLink_root__2jdyS {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 20px;\n  width: calc(100% - 25px);\n  box-shadow: 2px 1px 11px 3px rgba(175, 175, 175, 0.4);\n  border-radius: 15px;\n  margin: 10px auto 20px auto;\n  padding: 30px;\n  box-sizing: border-box; }\n  .dashboardLink_root__2jdyS .dashboardLink_link__30H-V {\n    font-size: 15px;\n    color: #3983f2; }\n", ""]);
// Exports
exports.locals = {
	"root": "dashboardLink_root__2jdyS",
	"link": "dashboardLink_link__30H-V"
};
module.exports = exports;
